export default [
  //FOR Vendor Manager========================================================================

  {
    subject: "vendor",
    key: "Pending Approval Vendors", //this is the parameter found in the url /form/:key
    pageTitle: "Vendor Pending Approval",
    editPage: "edit_form",  //the route to point when user select the add or edit button in the table
    previewPage: "view_form", //the route to point when user select the row in the table
    tableSettings: {
      route: "vendors",
      formType: "General",
      showItemPerPageOption: true,
      showSelectTable: false,
      uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
      //if don't want to have filter empty this.we filter the table based on this value
      filter: {
        status: "Pending Approval Vendors",
      },
      filterEndpoint: "getVendorWithStatusOnly",
      showAddBtn: false,
      showActionButton: false, //if this is false the add and edit button will not be shown
      showEditBtn: false,

    },
  },
  {
    subject: "vendor",
    key: "Rejected Vendors", //this is the parameter found in the url /form/:key
    pageTitle: "Vendor Pending Approval",
    editPage: "edit_form",  //the route to point when user select the add or edit button in the table
    previewPage: "view_form", //the route to point when user select the row in the table
    tableSettings: {
      route: "vendors",
      formType: "General",
      showItemPerPageOption: true,
      showSelectTable: false,
      uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
      //if don't want to have filter empty this.we filter the table based on this value
      filter: {
        status: "Rejected Vendors",
        branchId: ""
      },
      filterEndpoint: "getVendorWithStatusAndBranchId",
      showAddBtn: false,
      showActionButton: false, //if this is false the add and edit button will not be shown
      showEditBtn: false,

    },
  },
  {
    subject: "vendor",
    key: "Approved Vendors", //this is the parameter found in the url /form/:key
    pageTitle: "Approved Vendors",
    editPage: "edit_form",  //the route to point when user select the add or edit button in the table
    previewPage: "view_form", //the route to point when user select the row in the table
    tableSettings: {
      route: "vendors",
      formType: "General",
      showItemPerPageOption: true,
      showSelectTable: false,
      uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
      //if don't want to have filter empty this.we filter the table based on this value
      filter: {
        status: "Approved Vendors",
        branchId: ""
      },
      filterEndpoint: "getVendorWithStatusAndBranchId",
      showAddBtn: false,
      showActionButton: false, //if this is false the add and edit button will not be shown
      showEditBtn: false,

    },
  },

  //------------------------------------------------------------------------------------------

  //FOR Vendor ========================================================================
  {
    subject: "vendor",
    key: "profile", //this is the parameter found in the url /form/:key
    pageTitle: "Vendor Profile",
    editPage: "edit_form",  //the route to point when user select the add or edit button in the table
    previewPage: "view_form", //the route to point when user select the row in the table
    tableSettings: {
      route: "vendors",
      formType: "General",
      showItemPerPageOption: true,
      showSelectTable: false,
      uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
      //if don't want to have filter empty this.we filter the table based on this value
      filter: {
        userId: ""
      },
      filterEndpoint: "myVendor",
      showAddBtn: false,
      showActionButton: false, //if this is false the add and edit button will not be shown
      showEditBtn: false,

    },
  },
]
